<template>
	<div id="structure-view" style="display: block;">
		<div class="entry-view">
			<div 
				:style="
					$vuetify.breakpoint.mdAndDown
						? 'display: inline-block;'
						: 'display: block;'
				"
				style="
					position: relative;
					min-width: 100%;
					overflow: hidden;
				">
				<img
					v-if="$root.isImage(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
					:src="$root.asset(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
					style="display: block;"
					:style="
						$vuetify.breakpoint.mdAndDown
							? 'height: 100vmax;'
							: 'width: 100vmax;'
					"
				/>
				<video
					v-else-if="$root.isVideo(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)"
					style="display: block;"
					:style="
						$vuetify.breakpoint.mdAndDown
							? 'height: 100vmax;'
							: 'width: 100vmax;'
					"
					muted
					playsinline
					disablepictureinpicture
					loop="loop"
				>
					<source :src="$root.asset(structure.dataMap.backgroundLogin ? structure.dataMap.backgroundLogin : structure.background)" type="video/mp4" />
				</video>
				<v-row
					class="mx-0"
					style="
						position: fixed;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						overflow-y: auto;
					"
					:style="
						$vuetify.breakpoint.width < 350 ? 'height: 100vh;' : ''
					"
				>
					<v-col cols="12" class="d-flex justify-center align-center">
						<v-form ref="form" v-model="valid" @submit.prevent="register()">
							<v-card
								max-width="350"
								:style="
									$vuetify.breakpoint.smAndUp
										? 'width: 350px;'
										: 'width: 95vw;'
								"
								rounded="xl"
							>
								<v-card-title class="title d-flex justify-center align-center" style="color: white">
									<v-img v-if="structure.dataMap.logo" max-height="100" contain :src="
											$root.asset(structure.dataMap.logo)
										"></v-img>
								</v-card-title>
								<v-card-text v-if="!isSuccess">
									<v-text-field
										v-model="entity.firstName"
										:rules="[
											(v) =>
												!!v || 'FirstName is required',
										]"
										label="First Name"
										dense
										rounded
										filled
										required
									></v-text-field>

									<v-text-field
										v-model="entity.lastName"
										:rules="[
											(v) =>
												!!v || 'FirstName is required',
										]"
										label="Last Name"
										dense
										rounded
										filled
										required
									></v-text-field>

									<v-text-field
										v-model="entity.email"
										:rules="[
											(v) => !!v || 'E-mail is required',
											(v) =>
												/.+@.+\..+/.test(v) ||
												'E-mail must be valid',
										]"
										label="E-mail"
										dense
										rounded
										filled
										required
									></v-text-field>

									<v-text-field
										v-model="entity.password"
										:rules="[
											(v) =>
												!!v ||
												'Please specify password',
										]"
										:type="passwordFieldType"
										:append-icon="passwordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
										@click:append="switchVisibility1"
										label="Password"
										dense
										rounded
										filled
										required
									></v-text-field>

									<v-text-field
										v-model="entity.confirmPassword"
										:rules="[
											(v) =>
												!!v ||
												'Please confirm password',
											(v) =>
												(v && v === entity.password) ||
												'The password does not match',
										]"
										:type="confirmPasswordFieldType"
										:append-icon="confirmPasswordFieldType === 'password' ? 'mdi-eye' : 'mdi-eye-off'"
										@click:append="switchVisibility2"
										label="Confirm Password"
										dense
										rounded
										filled
										required
									></v-text-field>
									<v-row style="margin: 0" justify="end">
										<v-col cols="12" sm="8">
											<v-btn :disabled="!valid" class="v-unite-primary" type="submit" min-width="150" depressed rounded block>Register</v-btn>
										</v-col>
									</v-row>
								</v-card-text>
								<v-card-text v-else class="text-center">
									<h2 class="display-1">Congratulations</h2>
									<br />
									<p>
										Your account has been successfully
										created.
									</p>
									<v-btn
										class="v-unite-primary"
										:to="
											'/' +
											tenantSlug +
											'/' +
											experienceSlug
										"
									>Go back to login</v-btn>
								</v-card-text>
								<v-progress-linear rounded v-if="$root.loader.value" :indeterminate="$root.loader.value"></v-progress-linear>
								<div style="height: 20px"></div>
							</v-card>
						</v-form>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<style>
#structure-view .entry-view {
	overflow-x: auto;
	overflow-y: auto;
	width: auto;
	max-width: 100%;
	height: auto;
	margin: 0 auto;
}
.entry-view {
	/* position: relative; */
	margin: 0;
}
audio,
canvas,
progress,
video {
	display: inline-block;
	vertical-align: baseline;
}
</style>

<style scoped>
/* Let's get this party started */
::-webkit-scrollbar {
	height: 0px;
	width: 0px;
}
</style>

<script>
import axios from "axios";

export default {
	props: ["tenantSlug", "experienceSlug"],
	data() {
		return {
			valid: true,
			entity: { dataMap: {} },
			structure: { dataMap: {} },
			isSuccess: false,
			passwordFieldType: "password",
			confirmPasswordFieldType: "password",
			baseLocation: axios.defaults.baseURL
		};
	},
	mounted: function() {
		this.entrance();
	},
	methods: {
		entrance() {
			axios
				.get("/system/public/structure?tenantSlug=" + this.tenantSlug + "&experienceSlug=" + this.experienceSlug)
				.then(response => {
					this.structure = response.data;
				})
				.catch(() => {});
		},
		register() {
			this.entity.experienceId = this.structure.experienceId;
			this.entity.active = true;
			axios
				.post("/system/authentication/user/register", {
					entity: this.entity
				})
				.then(() => {
					this.isSuccess = true;
					this.$refs.form.reset();
				})
				.catch(() => {});
		},
		switchVisibility1() {
			this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
		},
		switchVisibility2() {
			this.confirmPasswordFieldType = this.confirmPasswordFieldType === "password" ? "text" : "password";
		},
	}
};
</script>